/**
 * Filter Persistence Utility
 * 
 * Saves/restores filter state per user + page in localStorage.
 * - 24-hour expiry
 * - Cleared on logout (via AuthContext)
 * - Reset via clearPageFilters()
 */

const EXPIRY_MS = 24 * 60 * 60 * 1000; // 24 hours
const PREFIX = 'crm_filters_';

function getKey(userId, pageId) {
  return `${PREFIX}${userId || 'anon'}_${pageId}`;
}

export function saveFilters(userId, pageId, filters) {
  try {
    const key = getKey(userId, pageId);
    localStorage.setItem(key, JSON.stringify({ v: filters, ts: Date.now() }));
  } catch { /* quota exceeded or private browsing */ }
}

export function loadFilters(userId, pageId) {
  try {
    const key = getKey(userId, pageId);
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const { v, ts } = JSON.parse(raw);
    if (Date.now() - ts > EXPIRY_MS) {
      localStorage.removeItem(key);
      return null;
    }
    return v;
  } catch {
    return null;
  }
}

export function clearPageFilters(userId, pageId) {
  try {
    localStorage.removeItem(getKey(userId, pageId));
  } catch { /* ignore */ }
}
